<template>
  <div class="clear" style="width:100%">
    <div class="ca">
      <p class="qdTitle">CA解密<span style="font-size: 14px;">（主持人可以帮现场的投标人解密）</span></p>
      <div class="errorMsg">
        <p>{{ errorMsg }}</p>
      </div>
      <div class="ca-jm-dom">
        <div ref="ca_jm_dom"></div>
      </div>
      <div style="text-align:center">
        <el-button
          type="primary"
          :disabled="waitLoading"
          @click="checkCAUserForm()"
          >解密</el-button
        >
        <el-button @click="bj" type="primary" v-if="jm" :disabled="waitLoading"
          >上传补救文件</el-button
        > 
        <el-button
          @click="sqbj"
          type="primary"
          v-if="!jm"
          :disabled="waitLoading"
          >申请补救</el-button
        >
      </div>
    </div>
    <!-- <div class="ewm">
      <div>
        <p class="qdTitle">二维码解密</p>
        <img
          :src="ewmUrl"
          alt=""
          style="width:243px;height:243px;margin-bottom:10px;"
          @click="getJmEwm()"
          v-if="sfApp"
        />
        <img
          src="../assets/images/sfApp.png"
          alt=""
          style="width:243px;height:243px;margin-bottom:10px;"
          v-else
        />
        <p>请用手机证书APP扫描二维码</p>
      </div>
    </div> -->
    <object
      id="USBKeyApi"
      classid="clsid:1246FA8B-41FD-4B45-90B8-47ED9772A1CD"
      style="position: absolute;top:-5000px"
    >
      <embed name="USBKeyApi" type="application/npSOFSignApi-plugin" />
    </object>
  </div>
</template>
<script>
import setting  from "@/settings"
export default {
  name: "jmCom",
  props: ["jm", "list", "sfApp"],
  data() {
    return {
      errorMsg: "",
      ewmUrl: "",
      jmewmDsq: null, //tbr验证是否扫码定时器
      getTime: null, //获取二维码的定时器2分钟一次
      role: localStorage.getItem("role") ? localStorage.getItem("role") : "T",
      waitLoading: false,
      lock_: null,
      config: {
        select: {
          style: {
            width: "380px",
            backgroundSize: "17px 14px",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "8px center",
          },
          placeholder: "请选择CA证书",
          userCheckRequest: setting.stystemLx,
          userCheckUrl:setting.caCheckUrl
        },
        detection: {
          name: "检 测",
        },
        pin: {
          style: {
            width: "480px",
            backgroundSize: "13px 21px",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "8px center",
          },
          maxLength: 16,
          placeholder: "请输入CA密码",
        },
        certInfoCode: [
          "NOTBEFORE",
          "AFTER",
          "ORGANIZATIONCODE",
          "SUBJECT_O",
          "PUBKEY",
        ], // 证书信息 不传默认返回锁的名字,证书序列号,锁的类型
        callback: (res) => {
          if (res.state == "succeed") {
            if (res.type == "login") {
              var jm = "";
              var jgdm = res.data.currentUser.ORGANIZATIONCODE
              this.list.forEach((e) => {
                if (e.fcqyjgdm == jgdm) {
                  jm = e.jmmw;
                }
              });
              var jmmw;
              if (jm) {
                if(res.data.currentUser.type == 'B'){
                    jmmw = this.lock_.USBKeyApi.PriKeyDecrypt(res.data.currentUser.code, jm);
                } else if (res.data.currentUser.type == 'A'){
                    jmmw = this.lock_.cwcaClient.SOF_DecryptData(res.data.currentUser.certOptID, jm);
                }
                
              } else {
                jmmw = "";
              }
              var obj = {
                jgdm: jgdm,
                jmmw: jmmw,
                caNo:res.data.currentUser.code
              };
              this.$emit("Qd", obj);
              this.errorMsg = "";
            }
          }
        },
        callMessage: {},
      },
    };
  },
  methods: {
    bj() {
      this.$emit("bj");
    },
    sqbj() {
      this.$emit("sqbj");
    },
    //获取二维码
    getJmEwm() {
      clearInterval(this.getTime);
      this.getTime = null;
      this.getTime = setInterval(() => {
        this.getJmEwm();
      }, 120000);
      if (this.role == "Z") {
        clearTimeout(this.jmewmDsq);
        this.jmewmDsq = null;
        this.$api
          .getJmEwm()
          .then((res) => {
            if (res.data.meta.success) {
              this.ewmUrl = "data:image/gif;base64," + res.data.data.picdata;
              this.uuid = res.data.data.uuid;
              this.setSrcJm();
            }
          })
          .catch(() => {});
      } else {
        clearTimeout(this.jmewmDsq);
        this.jmewmDsq = null;
        this.$api
          .getTbrJmEwm()
          .then((res) => {
            if (res.data.meta.success) {
              this.ewmUrl = "data:image/gif;base64," + res.data.data.picdata;
              this.uuid = res.data.data.uuid;
              this.setSrcJm();
            }
          })
          .catch(() => {});
      }
    },
    //验证扫描二维码是否成功
    setSrcJm() {
      let para = {
        uuid: this.uuid,
      };
      clearTimeout(this.jmewmDsq);
      this.jmewmDsq = null;
      this.jmewmDsq = setTimeout(() => {
        this.setSrcJm();
      }, 2000);
      if (this.role == "Z") {
        let _this = this;
        this.$api
          .setJmSrc(para)
          .then((res) => {
            //扫码成功后
            if (res.data.data != null && res.data.data != "") {
              clearInterval(_this.jmewmDsq);
              _this.jmewmDsq = null;
              let obj = {
                jgdm: res.data.data.jgdm,
                qymc: res.data.data.qymc,
              };
              this.$emit("ewmQd", obj);
            }
          })
          .catch(() => {});
      } else {
        let _this = this;
        this.$api
          .setTbrJmSrc(para)
          .then((res) => {
            //扫码成功后
            if (res.data.meta.success) {
              clearInterval(_this.jmewmDsq);
              _this.jmewmDsq = null;
              this.$emit("ewmQd");
            }
          })
          .catch(() => {});
      }
    },
    checkCAUserForm() {
      this.lock_.checkPin(this.lock_.currentUser)
    },
  },
  mounted() {
    clearInterval(this.getTime);
    this.getTime = null;
    clearTimeout(this.jmewmDsq);
    this.jmewmDsq = null;
    if (this.sfApp) {
      this.getJmEwm();
    }
    if (this.$refs.ca_jm_dom) {
      this.lock_ = new lock();
      this.lock_.init(this.$refs.ca_jm_dom, this.config);
    }
  },
  beforeDestroy() {
    clearInterval(this.getTime);
    this.getTime = null;
    clearTimeout(this.jmewmDsq);
    this.jmewmDsq = null;
  },
};
</script>
<style lang="less" scoped>
div.ca {
  width: 100%;
  padding: 0 80px 0 50px;
  float: left;
  height: 350px;
  .el-select {
    width: calc(~"100% - 110px");
    margin-right: 10px;
  }
}

div.ewm {
  > div {
    width: 250px;
    text-align: center;
    margin: 0 auto;
    p.qdTitle {
      text-align: left;
    }
  }
  width: 40%;
  float: left;
  position: relative;
  img {
    display: block;
    background: #fff;
  }
}
div.ewm:before {
  content: "";
  border-left: 1px solid #ddd;
  height: 320px;
  position: absolute;
  top: 0;
  left: 0;
}
p {
  color: #666;
  font-size: 16px;
}
p.qdTitle {
  color: #333;
  font-size: 18px;
  margin-bottom: 20px;
}
.allWidth {
  div.ca {
    width: 630px;
    text-align: center;
  }
  div.ewm {
    width: 500px;
  }
}
.ca-jm-dom {
  display: flex;
  justify-content: center;
}
</style>
